module.exports = __webpack_public_path__ + "static/media/loading.d357f8d4.gif";